import React, { forwardRef, memo } from 'react';
import { Flex, Field, HStack, IconButton, NumberInput } from '@chakra-ui/react';
import { LuMinus, LuPlus } from 'react-icons/lu';

interface InputFieldProps
  extends React.ComponentProps<typeof NumberInput.Root> {
  error?: string;
  width: string;
  text?: string;
}

const FormInputNumber = memo(
  forwardRef<HTMLDivElement, InputFieldProps>(
    ({ width, error, text, ...rest }, ref) => {
      return (
        <Field.Root
          pos="relative"
          w={width}
          invalid={!!error}
          display="flex"
          flexDirection="column"
        >
          {text && (
            <Field.Label mb="2" fontSize="14px" fontWeight="500">
              {text}
            </Field.Label>
          )}
          <NumberInput.Root ref={ref} unstyled spinOnPress={false} {...rest}>
            <HStack gap="1">
              <NumberInput.DecrementTrigger asChild>
                <IconButton
                  variant="outline"
                  size="xs"
                  w="28px"
                  h="28px"
                  minW="28px"
                  borderRadius="8px"
                  color={{ base: '#4E6E84', _dark: '#6090A8' }}
                  borderColor={{ base: 'rgba(0,0,0,0.1)', _dark: 'rgba(255,255,255,0.1)' }}
                  _hover={{ bg: 'rgba(0,176,202,0.08)', borderColor: '#00B0CA', color: '#00B0CA' }}
                  aria-label="Diminuir quantidade"
                >
                  <LuMinus />
                </IconButton>
              </NumberInput.DecrementTrigger>
              <NumberInput.ValueText
                textAlign="center"
                fontSize="14px"
                fontWeight="600"
                color={{ base: '#0A1B2B', _dark: '#E2EFF5' }}
                minW="2ch"
                px="2"
                py="0"
              />
              <NumberInput.IncrementTrigger asChild>
                <IconButton
                  variant="outline"
                  size="xs"
                  w="28px"
                  h="28px"
                  minW="28px"
                  borderRadius="8px"
                  color={{ base: '#4E6E84', _dark: '#6090A8' }}
                  borderColor={{ base: 'rgba(0,0,0,0.1)', _dark: 'rgba(255,255,255,0.1)' }}
                  _hover={{ bg: 'rgba(0,176,202,0.08)', borderColor: '#00B0CA', color: '#00B0CA' }}
                  aria-label="Aumentar quantidade"
                >
                  <LuPlus />
                </IconButton>
              </NumberInput.IncrementTrigger>
            </HStack>
          </NumberInput.Root>
          {error && (
            <Flex align="center" ml="1" mt="1">
              <Field.ErrorIcon w="3.5" h="3.5" mr="1" />
              <Field.ErrorText>{error}</Field.ErrorText>
            </Flex>
          )}
        </Field.Root>
      );
    },
  ),
);

FormInputNumber.displayName = 'FormInputNumber';

export default FormInputNumber;
